import { useState, useMemo } from "react";

export const useUserSelection = (filteredUsers) => {
  const [selectedRows, setSelectedRows] = useState([]);

  // Calculate actual selected count (only existing users)
  const actualSelectedCount = useMemo(() => {
    return selectedRows.filter(key =>
      filteredUsers.some(user => user.key === key)
    ).length;
  }, [selectedRows, filteredUsers]);

  const rowSelection = {
    selectedRowKeys: selectedRows,
    onChange: (selectedRowKeys) => {
      setSelectedRows(selectedRowKeys);
    },
  };

  return {
    selectedRows,
    setSelectedRows,
    actualSelectedCount,
    rowSelection
  };
}; 